import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

const UpdateStoreCart = ({
    currentStoreCart = [],
    setUpdated,
    updatedStoreData = [],
    updateRegistrationStoreCart,
    removeRegistrationStoreCartItem,
}) => {
    const dispatch = useDispatch();

    const updateStoreCartWithItemsInStock = (_updatedStoreData) => {
        currentStoreCart.forEach((cartItem) => {
            const { Product_Id, Field_Data_Id = "" } = cartItem;
            // Since we are mapping through and possibly removing items, we can't trust
            // the index to be accurately aligned. Instead we need to find the index of the updated
            // item that matches the current store cart item that is being mapped by it's
            // Product_Id and Field_Data_Id
            // Note both must be compared. A product without attributes will only have a Product_Id and
            // Field_Data_id with an empty string.  A product with attributes will have both unique
            // ids that will need to match
            const indexOfItemToUpdate = _updatedStoreData.findIndex(
                (itemToUpdate) =>
                    Number(itemToUpdate.Product_Id) === Product_Id &&
                    itemToUpdate.Field_Data_Id === Field_Data_Id,
            );

            // If there are items to be updated and we find the item in store cart then
            // either remove or update quantity
            if (updatedStoreData.length > 0 && indexOfItemToUpdate !== -1) {
                if (
                    updatedStoreData[indexOfItemToUpdate]?.isAvailable === false
                ) {
                    // If item is no longer available we need to remove it from the store cart
                    // error message will display letting user know why it has been removed
                    dispatch(
                        removeRegistrationStoreCartItem({
                            index: null,
                            productId: Product_Id,
                            fieldDataId: Field_Data_Id,
                        }),
                    );
                } else if (
                    updatedStoreData[indexOfItemToUpdate]?.isAvailable &&
                    updatedStoreData[indexOfItemToUpdate]?.Product_Quantity !==
                        cartItem.Product_Quantity
                ) {
                    // Replace the current item in cart with updated max inventory value
                    // if user was trying to purchase more than are in stock
                    const newCartItem = {
                        ...cartItem,
                        Product_Quantity:
                            updatedStoreData[indexOfItemToUpdate]
                                ?.Product_Quantity,
                    };
                    dispatch(
                        updateRegistrationStoreCart({
                            index: null,
                            productId: Product_Id,
                            fieldDataId: Field_Data_Id,
                            storeCart: newCartItem,
                        }),
                    );
                }
            }
        });
    };

    useEffect(() => {
        // This function only needs to run if a updated array is returned on the error
        // catch while submitting the registration
        if (updatedStoreData && updatedStoreData.length > 0) {
            Promise.all([
                updateStoreCartWithItemsInStock(updatedStoreData),
            ]).then(() => {
                // Clear updated array once the cart has been updated
                dispatch(setUpdated([]));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedStoreData]);

    return null;
};

UpdateStoreCart.propTypes = {
    currentStoreCart: PropTypes.arrayOf(PropTypes.shape({})),
    setUpdated: PropTypes.func.isRequired,
    updatedStoreData: PropTypes.arrayOf(
        PropTypes.shape({
            isAvailable: PropTypes.bool,
            Product_Quantity: PropTypes.number,
        }),
    ),
    updateRegistrationStoreCart: PropTypes.func.isRequired,
    removeRegistrationStoreCartItem: PropTypes.func.isRequired,
};

export default UpdateStoreCart;
